export default class extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]')
    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.toggle.bind(this))
      // Initialize state
      this.toggle()
    }
  }

  toggle() {
    const isChecked = this.checkbox.checked
    const container = this.closest('submitter-item')
    if (!container) return

    // Find elements to hide: Name field and the grid containing Email/Phone
    // We expect them to have the data-hide-on-bulk attribute
    const elementsToHide = container.querySelectorAll('[data-hide-on-bulk]')
    
    elementsToHide.forEach(el => {
      el.style.display = isChecked ? 'none' : ''
    })

    // Handle Email required
    const emailInput = container.querySelector('input[type="email"]')
    if (emailInput) {
      if (isChecked) {
        emailInput.removeAttribute('required')
      } else {
        emailInput.setAttribute('required', 'required')
      }
    }
  }
}
